import { render, staticRenderFns } from "./detailPage2.vue?vue&type=template&id=31d812a6&scoped=true"
import script from "./detailPage2.vue?vue&type=script&lang=js"
export * from "./detailPage2.vue?vue&type=script&lang=js"
import style0 from "./detailPage2.vue?vue&type=style&index=0&id=31d812a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d812a6",
  null
  
)

export default component.exports